var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconHamburger = function SvgIconHamburger(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 23 22"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 19.556h4a1 1 0 0 1 1 1v.22a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-.22a1 1 0 0 1 1-1m0-6h8a1 1 0 0 1 1 1v.22a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-.22a1 1 0 0 1 1-1m-1-3.89c0-.613.5-1.11 1.119-1.11h13.318c.618 0 1.119.493 1.119 1.11 0 .614-.5 1.112-1.12 1.112H2.12A1.11 1.11 0 0 1 1 9.667m0-6c0-.613.494-1.11 1.104-1.11h17.792c.61 0 1.104.493 1.104 1.11 0 .614-.494 1.112-1.104 1.112H2.104C1.494 4.778 1 4.285 1 3.667"
  }), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 13v8M22 18l-3 3M16 18l3 3"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M1 17.556h4a1 1 0 0 1 1 1v.22a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-.22a1 1 0 0 1 1-1m0-6h8a1 1 0 0 1 1 1v.22a1 1 0 0 1-1 1H1a1 1 0 0 1-1-1v-.22a1 1 0 0 1 1-1m-1-3.89c0-.613.5-1.11 1.119-1.11h13.318c.618 0 1.119.493 1.119 1.11 0 .614-.5 1.112-1.12 1.112H1.12A1.11 1.11 0 0 1 0 7.667m0-6C0 1.054.494.557 1.104.557h17.792c.61 0 1.104.493 1.104 1.11 0 .614-.494 1.112-1.104 1.112H1.104C.494 2.778 0 2.285 0 1.667"
  }), /*#__PURE__*/React.createElement("g", {
    stroke: "#000",
    strokeLinecap: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18 11v8M21 16l-3 3M15 16l3 3"
  })))));
};
export default SvgIconHamburger;